import React, { FC } from "react";

import { useTranslation } from "lib/i18n/use-translation";

import {
  CompletedNote,
  CompletionError,
  MechanicProps,
  useCompletion,
} from "./shared";
import styles from "../../december-doors.module.scss";

const DoneMechanic: FC<MechanicProps> = ({ door, onComplete }) => {
  const { t } = useTranslation(["decemberDoors"]);
  const { submit, isSaving, hasFailed } = useCompletion(onComplete);

  if (door.isCompleted) {
    return (
      <CompletedNote
        door={door}
        line={t("decemberDoors:mechanic.doneConfirm")}
      />
    );
  }

  return (
    <div className={styles.mechanic}>
      <button
        type="button"
        className={styles["mechanic-primary"]}
        onClick={() => submit(null)}
        disabled={isSaving}
      >
        {t("decemberDoors:mechanic.markDone")}
      </button>
      <CompletionError show={hasFailed} />
    </div>
  );
};

export default DoneMechanic;
